export default __webpack_public_path__ + "static/media/call.941480b7.svg";